// extracted by mini-css-extract-plugin
export default {"navFooter":"NavFooter_navFooter__RaeyJ","sidebar":"NavFooter_sidebar__rX0Ma","active":"NavFooter_active__NAgCv"};